import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {ICRMTasksWidgetModel} from '../../../model/widget.model';
import {BUSINESS_ROLES} from '../../../../../models/user.model';

@Component({
    selector: 'app-crm-tasks-widget.settings',
    templateUrl: './crm-tasks-widget.settings.component.html',
    styleUrl: './crm-tasks-widget.settings.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppTasksWidgetSettingsComponent {
    @Input() widget: ICRMTasksWidgetModel;
    public roles = BUSINESS_ROLES.filter(el => el !== 'all_roles')
        changeSettings(optionDictKey: string, target: any, widget: ICRMTasksWidgetModel): void {
        if (widget.options_dict[optionDictKey].includes(target)) {
            widget.options_dict[optionDictKey] = widget.options_dict[optionDictKey].filter(x => x !== target);
        } else {
            widget.options_dict[optionDictKey].push(target);
        }
    }
 }
 